import style from './style';

const Modal = ({ content, video, site, setShowModal, showModal }) => {
    const renderModal = modal => {
        if (modal.videoSrc) {
            return (
                <>
                    <div class={style['modal__video']}>
                        <button onClick={() => setShowModal(false)}/>
                        <video controls='true' poster={modal.poster} style={{width: '100%', maxWidth: '100%', maxHeight: '280px', backgroundColor: '#000'}}>
                            <source src={modal.videoSrc} type='video/mp4'/>
                        </video>
                    </div>
                </>
            )
        }

        return (
        <>
            <div class={style['modal__info']}>
                <div class={`${style['mi__image-wrapper']} ${style['mi__image-wrapper--' + site]}`}>
                    <img src={modal.imageSrc}/>
                </div>
                <div>
                    <h2>{modal.title}</h2>
                    {modal.paragraphs.map(p => <p>{p}</p>)} 
                </div>
            </div>
            <button onClick={() => setShowModal(false)}/>
        </>
    )}

    return (
        <div class={`${style['modal']} ${style[`modal--${site}`]}`}>
            {
                content === 'episode-1-nosik' && (
                    renderModal({
                        title: 'Антон Носик',
                        paragraphs: [
                            'журналист, стартап-менеджер, блогер, бывший главный редактор ряда проектов ФЭП (Фонда эффективной политики): Vesti.ru, Lenta.ru,' +
                            ' Gazeta.ru и NEWSru.com. Участвовал в развитии контент-проектов для интернет-провайдера CityLine, таких как блог "Вечерний интернет".' +
                            ' Умер в 2017 году от сердечного приступа.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-anton-nosik.jpg',
                    })
                )
            }
            {
                content === 'episode-1-revazov' && (
                    renderModal({
                        title: 'Арсен Ревазов',
                        paragraphs: [
                            'писатель, фотограф, автор "белой ленточки" – символа протестов, связанного с выборами в 2011 году. В 1999-м основал' +
                            ' рекламное агентство IMHO, в течение 12 лет эксклюзивно продающего баннеры на главной странице Yandex.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-arsen-revazov.jpg',
                    })
                )
            }
            {
                content === 'episode-1-lebedev' && (
                    renderModal({
                        title: 'Артемий Лебедев',
                        paragraphs: [
                            'первый веб-дизайнер в России. Обладатель одного из самых популярных ЖЖ, автор книги "Ководство",' +
                            ' отец десяти детей. Известен своей дерзостью в интернете и обилием нецензурной лексики в постах.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-artemy-lebedev.jpg',
                    })
                )
            }
            {
                content === 'episode-1-shiryanov' && (
                    renderModal({
                        title: 'Баян Ширянов',
                        paragraphs: [
                            'российский писатель. Первые тексты попали в интернет без ведома автора. Стал известен благодаря роману' +
                            ' "Низший пилотаж" о жизни московских наркоманов. В 2002 году книги Ширянова и Владимира Сорокина' +
                            ' публично уничтожали активисты движения "Идущие вместе". Писатель умер в 2017 году от цирроза печени.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-bayan-shiryanov.jpg',
                    })
                )
            }
            {
                content === 'episode-1-shuppe' && (
                    renderModal({
                        title: 'Георгий Шуппе',
                        paragraphs: [
                            'президент компании CityLine, сооснователь первого в России онлайн-медиа и контент-провайдера "Нетскейт",' +
                            ' купившего Anekdot.ru и создавшего "Вечерний интернет", "Паровозов-ньюс" и "Сеновал".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-egor-shuppe.jpg',
                    })
                )
            }
            {
                content === 'episode-1-kudryavtzev' && (
                    renderModal({
                        title: 'Демьян Кудрявцев',
                        paragraphs: [
                            'один из руководителей компании CityLine, гражданин Израиля. Впоследствии – генеральный директор ИД "Коммерсант",' +
                            ' акционер Sanoma Independent Media. В 2017 году МВД России отменило свое решение о предоставлении гражданства Кудрявцеву,' +
                            ' многие считают, что поводом послужили журналистские расследования.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-demyan-kudryavtzev.jpg',
                    })
                )
            }
            {
                content === 'episode-1-shatz' && (
                    renderModal({
                        title: 'Джоэл Шац',
                        paragraphs: [
                            'изучал психологию, химию, философию науки и теорию коммуникаций в 60-х. Работал в администрации штата Орегон.' +
                            ' Хиппи и любитель психоделических наркотиков. Создатель и идеолог первого телемоста между СССР и США, который,' +
                            ' по его задумке, должен был объединить людей так же, как это делают запрещенные вещества.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-joel-shatz.jpg',
                    })
                )
            }
            {
                content === 'episode-1-verner' && (
                    renderModal({
                        title: 'Дмитрий Вернер',
                        paragraphs: [
                            'профессор астрофизики и коллекционер анекдотов. Создатель сайта Anekdot.ru, на протяжении нескольких лет самого популярного' +
                            ' сайта России. После продажи проекта работал почтальоном в США, о чем писал в своем ЖЖ.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-dmitry-verner.jpg',
                    })
                )
            }
            {
                content === 'episode-1-itzkovich' && (
                    renderModal({
                        title: 'Дмитрий Ицкович',
                        paragraphs: [
                            'основатель и главный редактор Zhurnal.ru и Polit.ru. Создатель первого интеллектуального офлайн-клуба "Проект' +
                            ' "ОГИ", издатель и владелец сети модных рюмочных в Москве и Санкт-Петербурге.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-dmitry-itzkovich.jpg',
                    })
                )
            }
            {
                content === 'episode-1-zaharov' && (
                    renderModal({
                        title: 'Емельян Захаров',
                        paragraphs: [
                            'один их первых импортеров компьютеров в Россию, галерист. В настоящее время совладелец галереи современного искусства "Триумф".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-Emelyan-Zaharov.jpg',
                    })
                )
            }
            {
                content === 'episode-1-goldin' && (
                    renderModal({
                        title: 'Иосиф Гольдин',
                        paragraphs: [
                            'сценарист с репутацией "городского сумасшедшего". Организатор "сеансов по раскрепощению памяти",' +
                            ' любитель гипноза, психологии и скрытых возможностей человека.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-iosif-goldin.jpg',
                    })
                )
            }
            {
                content === 'episode-1-moshkov' && (
                    renderModal({
                        title: 'Максим Мошков',
                        paragraphs: [
                            'программист, веб-разработчик. Бывший сотрудник НИИ системных исследований РАН. Создатель "Библиотеки Максима Мошкова".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-maxim-moshkov.jpg',
                    })
                )
            }
            {
                content === 'episode-1-kolerov' && (
                    renderModal({
                        title: 'Модест Колеров',
                        paragraphs: [
                            'историк, издатель. Главный редактор и соучредитель информагентства REGNUM, президент издательского дома "Регнум".' +
                            ' За ряд публикаций Колерову запрещен въезд в Литву, Эстонию и Латвию.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-modest-kolerov.jpg',
                    })
                )
            }
            {
                video === 'episode-1-dve-devushki-v-chas' &&
                renderModal({ 
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/dve-devushki-v-chas.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/dve-devushki-v-chas-poster.jpg',
                })
            }
            {
                video === 'episode-1-nedostatok-contenta' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/nedostatok-contenta.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/nedostatok-contenta-poster.jpg',
                })
            }
            {
                video === 'episode-1-cityline' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/cityline.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/cityline-poster.jpg',
                })
            }

            {
                video === 'episode-1-seksa-u-nas-net' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/seksa-net.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/seksa-net-poster.jpg',
                })
            }

            {
                content === 'episode-2-pavlovsky' && (
                    renderModal({
                        title: 'Глеб Павловский',
                        paragraphs: [
                            'советский диссидент, журналист, политолог. Соучредитель и директор Фонда эффективной политики.' +
                            ' Был советником руководителя администрации президента РФ, после чего ушел в оппозицию.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-gleb-pavlovsky.jpg',
                    })
                )
            }

            {
                content === 'episode-2-lavrov' && (
                    renderModal({
                        title: 'Егор "Скелетрон" Лавров',
                        paragraphs: [
                            'создатель журнала "Планета Internet" об интернете и сайта Фак.ру. В 19 лет Лавров возглавил предвыборный штаб' +
                            ' Умара Джабраилова. Сейчас работает в каннабисной индустрии.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-egor-lavrov.jpg',
                    })
                )
            }
            {
                content === 'episode-2-rykov' && (
                    renderModal({
                        title: 'Константин "Форис" Рыков',
                        paragraphs: [
                            'создатель сайта Фак.ру, медиаменеджер, депутат Государственной думы V созыва. В течение двух лет возглавлял интернет-департамент Первого канала. ' +
                            'Создатель ряда интернет-кампаний в поддержку Владимира Путина и Дмитрия Медведева.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-konstantin-rykov.jpg',
                    })
                )
            }
            {
                content === 'episode-2-belinsky' && (
                    renderModal({
                        title: 'Дмитрий "Линкси" Белинский',
                        paragraphs: [
                            'веб-дизайнер. Существует мнение, что именно он создал "олбанский" язык и был ответственен за' +
                            ' креатив в Фак.ру. Создал дизайн многим порносайтам в 90-х, работал на Первом канале, однако' +
                            ' так и не смог уговорить руководство поменять дизайн.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-dmitry-belinsky.jpg',
                    })
                )
            }
            {
                content === 'episode-2-eremin' && (
                    renderModal({
                        title: 'Степан Еремин',
                        paragraphs: [
                            'разработчик и руководитель портала Padonki.org, создатель асоциального проекта Х*ЯNDEX и прочих.' +
                            ' Сейчас занимается проектом Kaktam.tv – ютуб-каналом с матерными новостями.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-stepan-eremin.jpg',
                    })
                )
            }
            {
                video === 'episode-2-my-nauchili' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/my-nauchili.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/my-nauchili-poster.jpg',
                })
            }
            {
                video === 'episode-2-nosik-putinu' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/nosik-putinu.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/nosik-putinu-poster.jpg',
                })
            }
            {
                content === 'episode-3-krukov' && (
                    renderModal({
                        title: 'Дмитрий Крюков',
                        paragraphs: [
                            'программист, автор первой поисковой системы в России Rambler. Разработал программу в свободное' +
                            ' от работы в Институте биохимии время и запустил в собственный день рождения как подарок самому' +
                            ' себе. Умер в 2009 году от внутримозгового кровоизлияния.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-dmitry-krukov.jpg',
                    })
                )
            }
            {
                content === 'episode-3-lysakov' && (
                    renderModal({
                        title: 'Сергей Лысаков',
                        paragraphs: [
                            'программист, сооснователь и бывший генеральный директор Rambler. До открытия компании вместе с Дмитрием Крюковым работал в Институте биохимии в Пущине.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-sergey-lisakov.jpg',
                    })
                )
            }
            {
            content === 'episode-3-segalovich' && (
                renderModal({
                    title: 'Илья Сегалович',
                    paragraphs: [
                        'программист, предприниматель, сооснователь и директор по технологиям Yandex. Познакомился со вторым основателем' +
                        ' компании Аркадием Воложем в 1977 году во время учебы в школе в Алма-Ате. В 1981-м они вместе переехали в Москву,' +
                        ' чтобы поступить на геологический факультет МГУ, но оба не прошли конкурс. Разработчик морфологии поисковика и ' +
                        'создатель первого российского сервиса контекстной рекламы "Яндекс. Директ". Умер в 2013 году от рака мозга.',
                    ],
                    imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-ilya-segalovich.jpg',
                })
            )
        }
            {
                content === 'episode-3-volozh' && (
                    renderModal({
                        title: 'Аркадий Волож',
                        paragraphs: [
                            'сооснователь и руководитель группы компаний Yandex. В 1989 году открыл компанию по продаже компьютеров и программного' +
                            ' обеспечения CompTek. С 2007 года заведующий кафедрой "Анализ данных" МФТИ. По оценке журнала Forbes занимает 65 место' +
                            ' среди самых богатых людей России.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-arkadiy-volozh.jpg',
                    })
                )
            }
            {
                content === 'episode-3-radzinsky' && (
                    renderModal({
                        title: 'Олег Радзинский',
                        paragraphs: [
                            'писатель, диссидент, инвестиционный банкир. Родился в семье драматурга Эдварда Радзинского и актрисы Аллы Гераскиной.' +
                            ' Окончил филологический факультет МГУ. В 1982 году был арестован на пять лет по статье "Антисоветская агитация и пропаганда".' +
                            ' В 1987 году был выслан из страны и поселился в США, где поступил в Колумбийский университет. Совладелец Rambler Media Group' +
                            ' в 2002-2006-м. Благодаря усилиям Радзинского компания в 2005 году вышла на IPO.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-oleg-radzinsky.jpg',
                    })
                )
            }
            {
                video === 'episode-3-yandex' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/yandex.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/yandex-poster.jpg',
                })
            }
            {
                video === 'episode-3-dotkom' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/dotkom.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/dotkom-poster.jpg',
                })
            }
            {
                video === 'episode-3-lekala' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/lekala.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/lekala-poster.jpg',
                })
            }
            {
                content === 'episode-4-krivenkov' && (
                    renderModal({
                        title: 'Алексей Кривенков',
                        paragraphs: [
                            'разработчик первого русскоязычного почтового сервиса Mail.ru. В 1996 году бросил учебу в России' +
                            ' и уехал покорять Нью-Йорк, где познакомился с будущим бизнес-партнером Евгением Голландом. Спустя' +
                            ' 2 года запустил сайт Mail.ru и вернулся в Россию.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-alexey-krivenkov.jpg',
                    })
                )
            }
            {
                content === 'episode-4-matzanuk' && (
                    renderModal({
                        title: 'Игорь Мацанюк',
                        paragraphs: [
                            'предприниматель, соучредитель IT Territory, одной из первых компаний-разработчиков' +
                            ' онлайн-игр в России. Окончил Высшее инженерное морское училище, в 90-х занимался' +
                            ' продажей автомобильных запчастей. В 2004 году открыл компанию It Territory совместно' +
                            ' с Сергеем Жуковым, а после – компанию Game insight. Живет в США.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-igor-matzanuk.jpg',
                    })
                )
            }
            {
                content === 'episode-4-usmanov' && (
                    renderModal({
                        title: 'Алишер Усманов',
                        paragraphs: [
                            'один из богатейших людей РФ, предприниматель, меценат. Родился в Ташкенте. В 1987 году учредил кооператив' +
                            ' "Агропласт", занимался производством пластиковых пакетов и поставкой табака. Соучредитель компании' +
                            ' "Металлоинвест", МАПО-банка, бывший советник председателя правления ОАО "Газпром" и генеральный' +
                            ' директор "Газпроминвестхолдинга". Инвестировал в первые международные фонды под правлением DST Global.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-alisher-usmanov.jpg',
                    })
                )
            }
            {
                content === 'episode-4-dobrodeev' && (
                    renderModal({
                        title: 'Борис Добродеев',
                        paragraphs: [
                            'сын генерального директора ВГТРК Олега Добродеева. Окончил исторический факультет МГУ.' +
                            ' Работал аналитиком в компании "Металлоинвест" Алишера Усманова и DST Advisers Юрия Мильнера.' +
                            ' После увольнения Павла Дурова стал генеральным директором "ВКонтакте", а позже стал директором Mail.ru Group',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-boris-dobrodeev.jpg',
                    })
                )
            }
            {
                content === 'episode-4-grishin' && (
                    renderModal({
                        title: 'Дмитрий Гришин',
                        paragraphs: [
                            'председатель совета директоров и сооснователь Mail.ru Group, занимался развитием коммуникационных' +
                            ' сервисов и онлайн-игр компании. В 2012 году открыл в США венчурную компанию Grishin Robotics для' +
                            ' инвестиций в робототехнику.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-dmitry-grishin.jpg',
                    })
                )
            }
            {
                content === 'episode-4-zhukov' && (
                    renderModal({
                        title: 'Сергей Жуков',
                        paragraphs: [
                            'музыкант, солист группы "Руки Вверх!" Один из соучредителей компании It Territory, создавшей' +
                            ' онлайн-игры "Территория" и "Легенда: Наследия Драконов". В 2005 году продал свою долю компании' +
                            ' Mail.ru Group.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-sergey-zhukov.jpg',
                    })
                )
            }
            {
                content === 'episode-4-popkov' && (
                    renderModal({
                        title: 'Альберт Попков',
                        paragraphs: [
                            'российский программист, создатель сайта Odnoklassniki.ru. Подростком разрабатывал программное' +
                            ' обеспечение для советских игровых компьютеров "Корвет". В 90-х работал продавцом, строителем' +
                            ' и сушильщиком на карандашной фабрике. Сайт Odnoklassniki.ru создал во время шестимесячного' +
                            ' перерыва между работой программистом в одной справочной службе и переходом в другую.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-albert-popkov.jpg',
                    })
                )
            }
            {
                content === 'episode-4-leviev' && (
                    renderModal({
                        title: 'Лев Левиев',
                        paragraphs: [
                            'инвестор, предприниматель, сооснователь "ВКонтакте". Вырос в Волгограде, в 90-х переехал в' +
                            ' Израиль, где во время учебы в школе познакомился с будущим партнером по бизнесу Вячеславом' +
                            ' Мирилашвили. Окончил Университет Макгилла в Канаде. Сооснователь компании-оператора дата-центров' +
                            ' Selectel и платформы BlockTrail для операций с биткоинами.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-lev-leviev.jpg',
                    })
                )
            }
            {
                content === 'episode-4-durov' && (
                    renderModal({
                        title: 'Павел Дуров',
                        paragraphs: [
                            'программист, предприниматель, сооснователь "ВКонтакте". Окончил филологический факультет' +
                            ' СПБГУ по специальности " Английская филология и перевод". В 2013 году покинул Россию,' +
                            ' заявив, что "в этой стране невозможно вести бизнес". В том же году запустил мессенджер Telegram.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-pavel-durov.jpg',
                    })
                )
            }
            {
                content === 'episode-4-lobushkin' && (
                    renderModal({
                        title: 'Георгий Лобушкин',
                        paragraphs: [
                            'бывший руководитель пресс-службы "ВКонтакте" (2011-2016 годы) и директор по стратегическим' +
                            ' коммуникациям Mail.ru Group (2016-2017 годы). В настоящее время занимается связями с' +
                            ' общественностью такси-сервиса "Ситимобил".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-georgy-lobushkin.jpg',
                    })
                )
            }
            {
                content === 'episode-4-milner' && (
                    renderModal({
                        title: 'Юрий Мильнер',
                        paragraphs: [
                            'один из самых влиятельных глобальных инвесторов, выпускник Уортонской школы бизнеса. ' +
                            'В 90-х занимал пост гендиректора компании "Альянс-Менатеп", был вице-президентом банка ' +
                            '"Менатеп", принадлежащего Михаилу Ходорковскому и Платону Лебедеву. Инвестировал в Facebook,' +
                            ' Twitter, WhatsApp, AirBnB. Бывший совладелец и председатель совета директоров Mail.ru Group' +
                            ' – технологической компании, владеющей "ВКонтакте", "Одноклассниками", Mamba.ru и десятками' +
                            ' других платформ. В 2012 году Мильнер ушел из Mail.ru Group, решив полностью сфокусироваться' +
                            ' на зарубежных проектах.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-yury-milner.jpg',
                    })
                )
            }
            {
                video === 'episode-4-sechin' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/sechin.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/sechin-poster.jpg',
                })
            }
            {
                video === 'episode-4-bashnya' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/bashnya.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/bashnya-poster.jpg',
                })
            }
            {
                video === 'episode-4-sekta' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/sekta.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/sekta-poster.jpg',
                })
            }
            {
                content === 'episode-5-navalny' && (
                    renderModal({
                        title: 'Алексей Навальный',
                        paragraphs: [
                            'политик, юрист, общественный деятель. Создатель Фонда борьбы с коррупцией, автор двух ютуб-каналов. Занял второе место на выборах мэра Москвы в 2013 году, до президентских выборов в 2016 году не был допущен. Автор мема "партия жуликов и воров" и одного из самых популярных блогов в "Живом Журнале", заблокированного Роскомнадзором.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Alexey-Navalny.jpg',
                    })
                )
            }
            {
                content === 'episode-5-klishas' && (
                    renderModal({
                        title: 'Андрей Клишас',
                        paragraphs: [
                            'политик, предприниматель, миллионер. В 90-х работал в Российском фонде федерального имущества, бывший президент "Норильского никеля". Автор законопроекта "О суверенном интернете".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Andrey-Klishas.jpg',
                    })
                )
            }
            {
                content === 'episode-5-logovoy' && (
                    renderModal({
                        title: 'Андрей Луговой',
                        paragraphs: [
                            'политик, предприниматель. Родился в семье военнослужащих. В 90-х работал в Главном управлении охраны РФ и Службе безопасности президента РФ, позже возглавил службу безопасности телеканала ОРТ. Директор группы охранных предприятий и совладелец компании, выпускающей квас. Подозревается прокуратурой Великобритании в убийстве Александра Литвиненко. Автор закона о блокировке экстремистских сайтов и закона о "суверенном интернете".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Andrey-Lugovoy.jpg',
                    })
                )
            }
            {
                content === 'episode-5-kozlyuk' && (
                    renderModal({
                        title: 'Артем Козлюк',
                        paragraphs: [
                            'общественный и политический деятель. Член штаба Пиратской партии России, руководитель проекта "РосКомСвобода", соучредитель и член правления "Ассоциации пользователей интернета".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Artem-Kozlyuk.jpg',
                    })
                )
            }
            {
                content === 'episode-5-pastshenko' && (
                    renderModal({
                        title: 'Григорий Пащенко',
                        paragraphs: [
                            'глава общественного движения "Кибердружина". По словам Пащенко, дружинники закрыли около 50 "серьезных экстремистских сообществ", среди которых паблик "Синий кит".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Grigory-Pastshenko.jpg',
                    })
                )
            }
            {
                content === 'episode-5-malofeev' && (
                    renderModal({
                        title: 'Константин Малофеев',
                        paragraphs: [
                            'предприниматель, основатель телеканала Царьград ТВ, основатель и член попечительского совета "Лиги безопасного интернета". Осенью 2019 года занял пост председателя наблюдательного совета Международного агентства суверенного развития –негосударственной организации, которая, по словам Малофеева помогает "с экономическим реформированием тем странам, которые пытаются освободиться от экономической и финансовой зависимости от западного мира".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Konstantin-Malofeev.jpg',
                    })
                )
            }
            {
                content === 'episode-5-potupchik' && (
                    renderModal({
                        title: 'Кристина Потупчик',
                        paragraphs: [
                            'общественный деятель, блогер. Бывший комиссар и пресс-секретарь движения "Наши", бывший пресс-секретарь агентства Росмолодежь и член Общественной палаты РФ 5-го состава.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Kristina-Potupchik.jpg',
                    })
                )
            }
            {
                content === 'episode-5-fitzpatrick' && (
                    renderModal({
                        title: 'Брэд Фицпатрик',
                        paragraphs: [
                            'американский программист. Родился в Айове. Во время учебы в Вашингтонском университете в Сиэтле создал сайт LiveJournal для собственного использования. Сейчас живет в Сан-Франциско и работает в компании Google.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Brad-Fitzpatrick.jpg',
                    })
                )
            }
            {
                content === 'episode-5-asmolov' && (
                    renderModal({
                        title: 'Григорий Асмолов',
                        paragraphs: [
                            'научный сотрудник Института России Королевского колледжа Лондона, создатель "Карты помощи пострадавшим от пожаров" в 2010 году. Сейчас продолжает исследовать роль соцсетей и информационных технологий в формировании сознания народных масс.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Grigory-Asmolov.jpg',
                    })
                )
            }
            {
                content === 'episode-5-surkov' && (
                    renderModal({
                        title: 'Владислав Сурков',
                        paragraphs: [
                            'политик, помощник президента РФ. В 1999 году стал заместителем руководителя администрации президента РФ. Считается одним из создателей и главных идеологов партии "Единая Россия", а также молодежных проектов "Идущие вместе" и "Наши". Любитель русского рока, соавтор нескольких текстов песен Вадима Самойлова – бывшего участника группы "Агата Кристи".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Vladislav-Surkov.jpg',
                    })
                )
            }
            {
                content === 'episode-5-yakemenko' && (
                    renderModal({
                        title: 'Василий Якеменко',
                        paragraphs: [
                            'политик, общественный деятель, идеолог молодёжных движений "Идущие вместе" (2000 г.), "Наши" (2005 г.) и молодежного форума "Селигер". С 2007 Якеменко запрещен въезд в страны Шенгенского договора по требованию Эстонии, обвинившей политика в организации нападения на посла Марину Кальюранд. С 2017 года занимается бизнесом: открыл сеть кафе "Ешь пирог", коуч-сервис "Адвокат тела" и "Школу великих книг".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Vasily-Yakemenko.jpg',
                    })
                )
            }
            {
                content === 'episode-5-mamuta' && (
                    renderModal({
                        title: 'Александр Мамут',
                        paragraphs: [
                            'предприниматель, миллиардер. Соучредитель и бывший акционер сети магазинов "Седьмой континент", бывший председатель совета директоров МДМ-банка, компании "Тройка Диалог", а также бывший член совета директоров "Ингосстраха". В 2007 году организовал компанию SUP, купившую сервис LiveJournal. В 2008 году выкупил 100 % акций компании "Евросеть", после возбуждения уголовного дела против основателя компании Евгения Чичваркина. Управляющий акционер Rambler&Co, владелец сети кинотеатров "Синема парк" и "Формула кино".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Aleksandr-Mamut.jpg',
                    })
                )
            }
            {
                content === 'episode-5-okhotin' && (
                    renderModal({
                        title: 'Григорий Охотин',
                        paragraphs: [
                            'журналист, независимый исследователь. Сооснователь правозащитного проекта "ОВД-Инфо" и Data4Society – сообщества журналистов и программистов, занимающихся анализом и популяризацией общественно полезных данных.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Grigory-Okhotin.jpg',
                    })
                )
            }
            {
                content === 'episode-5-zubareva' && (
                    renderModal({
                        title: 'Евгений Зубарев',
                        paragraphs: [
                            'журналист. Бывший редактор "Росбалта", руководитель агентства РИА ФАН, предположительно одного из проектов "фабрики троллей". В 2018 году Минфин США ввел санкции против РИА ФАН по причине связей проекта с "поваром Путина" Евгением Пригожиным.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Evgeny-Zubarev.jpg',
                    })
                )
            }
            {
                content === 'episode-5-malofeeva' && (
                    renderModal({
                        title: 'Константин Малофеев',
                        paragraphs: [
                            'предприниматель, основатель телеканала Царьград ТВ, основатель и член попечительского совета "Лиги безопасного интернета". Осенью 2019 года занял пост председателя наблюдательного совета Международного агентства суверенного развития –\n' +
                            '\n' +
                            'негосударственной организации, которая, по словам Малофеева помогает "с экономическим реформированием тем странам, которые пытаются освободиться от экономической и финансовой зависимости от западного мира".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Konstantin-Malofeev.jpg',
                    })
                )
            }
            {
                content === 'episode-5-bokovaya' && (
                    renderModal({
                        title: 'Боковая',
                        paragraphs: [
                            '',
                        ],
                        imageSrc: '',
                    })
                )
            }
            {
                content === 'episode-6-khomaka' && (
                    renderModal({
                        title: 'Давид Хомак',
                        paragraphs: [
                            'программист, один из создателей и владелец сайта Луркоморье. В 2013 году был вынужден эмигрировать в Израиль из-за проблем с Роскомнадзором и Центром по борьбе с экстремизмом',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-David-Homak.jpg',
                    })
                )
            }
            {
                video === 'episode-6-lurk' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-01-Lurk.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-01-Lurk-poster.jpg',
                })
            }
            {
                content === 'episode-6-segalovich' && (
                    renderModal({
                        title: 'Илья Сегалович',
                        paragraphs: [
                            'программист, предприниматель, сооснователь и директор по технологиям Yandex. Познакомился со вторым основателем компании Аркадием Воложем в 1977 году во время учебы в школе в Алма-Ате. В 1981-м они вместе переехали в Москву, чтобы поступить на геологический факультет МГУ, но оба не прошли конкурс. Разработчик морфологии поисковика и создатель первого российского сервиса контекстной рекламы "Яндекс. Директ". Умер в 2013 году от рака мозга.',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-ilya-segalovich.jpg',
                    })
                )
            }
            {
                content === 'episode-6-mamuta' && (
                    renderModal({
                        title: 'Александр Мамут',
                        paragraphs: [
                            'предприниматель, миллиардер. Соучредитель и бывший акционер сети магазинов "Седьмой континент", бывший председатель совета директоров МДМ-банка, компании "Тройка Диалог", а также бывший член совета директоров "Ингосстраха". В 2007 году организовал компанию SUP, купившую сервис LiveJournal. В 2008 году выкупил 100 % акций компании "Евросеть", после возбуждения уголовного дела против основателя компании Евгения Чичваркина. Управляющий акционер Rambler&Co, владелец сети кинотеатров "Синема парк" и "Формула кино".',
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Aleksandr-Mamut.jpg',
                    })
                )
            }
            {
                content === 'episode-6-timchenko' && (
                    renderModal({
                        title: 'Галина Тимченко',
                        paragraphs: [
                            'журналист, бывший главный редактор Lenta.ru (2004-2014). Генеральный директор и учредитель новостного проекта Meduza – русскоязычного портала, зарегистрированного в Латвии. После скандального увольнения из Lenta.ru за Тимченко в новый проект ушли 77 из 84 журналистов издания.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Galina-Timchenko.jpg',
                    })
                )
            }
            {
                content === 'episode-6-navalny' && (
                    renderModal({
                        title: 'Алексей Навальный',
                        paragraphs: [
                            'политик, юрист, общественный деятель. Создатель Фонда борьбы с коррупцией, автор двух ютуб-каналов. Занял второе место на выборах мэра Москвы в 2013 году, до президентских выборов в 2016 году не был допущен. Автор мема "партия жуликов и воров" и одного из самых популярных блогов в "Живом Журнале", заблокированного Роскомнадзором.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-Alexey-Navalny.jpg',
                    })
                )
            }
            {
                video === 'episode-6-putin' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-03-Putin.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-03-Putin-poster.jpg',
                })
            }
            {
                content === 'episode-6-klimovoy' && (
                    renderModal({
                        title: 'Лена Климова',
                        paragraphs: [
                            'журналист, ЛГБТ-активистка, создатель просветительского проекта "Дети-404", занимающегося проблемами ЛГБТ-подростков. В 2015 году была оштрафована за " пропаганду нетрадиционных сексуальных отношений среди несовершеннолетних". Автор серии фотоколлажей "Красивые люди и то, что они говорят мне" о гомофобии.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Lena-Klimova.jpg',
                    })
                )
            }
            {
                video === 'episode-6-aerosol' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-02-Aerosol.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/06-02-Aerosol-poster.jpg',
                })
            }
            {
                content === 'episode-6-klimenko' && (
                    renderModal({
                        title: 'Герман Клименко',
                        paragraphs: [
                            'интернет-предприниматель, владелец компании LiveInternet и MediaMetricks – новостного агрегатора данных на основе соцсетей. С 2016 по 2018-й был советником президента РФ по вопросам развития интернета.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-herman-klimenko.jpg',
                    })
                )
            }
            {
                content === 'episode-6-kalvi' && (
                    renderModal({
                        title: 'Майкл Калви',
                        paragraphs: [
                            'международный инвестовр, основатель фонда Baring Vostok Capital Partners, специализирующегося на инвестициях в России и странах СНГ. Инвестировал такие проекты, как Avito, "1C", "Вкусвилл", Busfor, "Тинькофф банк" и многие другие. Общий объем инвестиций фонда с 1994 года превысил $2,4 млрд. В 2019 году Калви предъявили обвинения в мошенничестве в особо крупном размере, арестовав все его имущество. Инвестор находится под домашним арестом.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Michael-Calvi.jpg',
                    })
                )
            }
            {
                content === 'episode-7-degtyarev' && (
                    renderModal({
                        title: 'Юрий Дегтярев',
                        paragraphs: [
                            'основатель одного из первых русскоязычных ютуб-блогов My Duck\'s vision. Бывший работник Rutube и один из создателей "Спасибо, Ева!"'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-yury-degtyarev.jpg',
                    })
                )
            }
            {
                content === 'episode-7-nikel' && (
                    renderModal({
                        title: 'Сэм Никель',
                        paragraphs: [
                            'блогер, музыкант. Один из авторов и главное действующее лицо блога My Duck\'s Vision. Лидер группы Candid8.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-sam-nickel.jpg',
                    })
                )
            }
            {
                content === 'episode-7-parfenov' && (
                    renderModal({
                        title: 'Леонид Парфенов',
                        paragraphs: [
                            'журналист, писатель, телеведущий, блогер, режиссер. Автор телепроектов "Намедни" и "Российская империя". С 1997-го до 1999-го был главным продюсером телеканала НТВ. В 2012 году начал работать на телеканале "Дождь", в 2018-м открыл авторское шоу в ютубе "Парфенон".'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-leonid-parfenov.jpg',
                    })
                )
            }
            {
                content === 'episode-7-zheludya' && (
                    renderModal({
                        title: 'Рома Желудь',
                        paragraphs: [
                            'видеоблогер, музыкант. На волне успеха в ютубе пробовал себя в качестве певца, телеведущего и дизайнера. Общее количество просмотров на двух каналах Желудя (RomaAcorn и RomaAcornLive) на февраль 2015 года превышало 108 миллионов. В марте 2015 года переехал жить в США, но спустя время вернулся в Россию.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-roma-zhelud.jpg',
                    })
                )
            }
            {
                content === 'episode-7-prusikin' && (
                    renderModal({
                        title: 'Илья ("Ильич") Прусикин',
                        paragraphs: [
                            'российский музыкант, видеоблогер, лидер группы Little big. Автор двух шоу, выходивших на ютуб-канале "Спасибо, Ева!", "Шоу Гаффи Гафа" и "Великая рэп-битва". Один из создателей объединения блогеров "КЛИККЛАК". В августе 2019 года стал креативным директором "Связного-Евросеть". Клип на песню Skibidi стал самым популярным российским видео в мире.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ilya-prusikin.jpg',
                    })
                )
            }
            {
                content === 'episode-7-usachev' && (
                    renderModal({
                        title: 'Руслан Усачев',
                        paragraphs: [
                            'видеоблогер, автор шоу Usachev today, выходившего на канале "Спасибо, Ева!", а также проектов "Вредное кино", Twitotta, "Микрообзоры" и "Пора валить". Сейчас у ютуб-канала Усачева около 2 миллионов подписчиков.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ruslan-usachev.jpg',
                    })
                )
            }
            {
                content === 'episode-7-dud' && (
                    renderModal({
                        title: 'Юрий Дудь',
                        paragraphs: [
                            'журналист, блогер. Бывший главный редактор издания Sports.ru. С 2017 года — ведущий авторского шоу на ютуб-канале "вДудь", где берет неформальные интервью у известных людей. У канала Дудя более 6,2 миллионов подписчиков.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-yury-dud.jpg',
                    })
                )
            }
            {
                content === 'episode-7-poperechny' && (
                    renderModal({
                        title: 'Данила Поперечный',
                        paragraphs: [
                            'видеоблогер, стендап-комик. Бывший мультипликатор "Спасибо, Ева!" Автор шоу "Зашкварные истории" на ютуб-канале "КЛИККЛАК" и один из создателей портала "ДавайЛайма". У ютуб-канала Поперечного более 2,6 миллионов подписчиков.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-danila-poperechny.jpg',
                    })
                )
            }
            {
                content === 'episode-7-icepeak' && (
                    renderModal({
                        title: 'IC3PEAK',
                        paragraphs: [
                            '(Настя Креслина, Николай Костылев) — музыкальная витч-хаус группа. Позиционируют себя как "интернет-группа". С 2018 года концерты группы в российских городах отменяют представители правоохранительных органов.'
                        ],
                        imageSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ice-peak.jpg',
                    })
                )
            }
            {
                video === 'episode-7-jelud' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-jelud.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-jelud-poster.jpg',
                })
            }
            {
                video === 'episode-7-meeting' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-meeting.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-meeting-poster.jpg',
                })
            }
            {
                video === 'episode-7-money' &&
                renderModal({
                    videoSrc: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-money.mp4',
                    poster: 'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/07-money-poster.jpg',
                })
            }


            
        </div>
    )
}

export default Modal;
